// Public share links must never point to the editor's preview origin.
// This is the primary published URL confirmed in the project's publishing settings.
const PUBLIC_ORIGIN = 'https://www.viysr.com';

export function publicProfileUrl(slugOrId) {
  if (slugOrId == null || String(slugOrId).trim() === '') return '';
  return `${PUBLIC_ORIGIN}/advisor/${encodeURIComponent(String(slugOrId).trim())}`;
}

export function linkedInComposerUrl(profileUrl) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(profileUrl)}`;
}
